import React from 'react';
import { Award } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

const STATUS_STYLE = {
  open:'bg-emerald-100 text-emerald-700', upcoming:'bg-amber-100 text-amber-700',
  closed:'bg-gray-100 text-gray-600', active:'bg-emerald-100 text-emerald-700',
  completed:'bg-blue-100 text-blue-700', pending:'bg-amber-100 text-amber-700',
};

// Format amount: show raw number with user-supplied currency symbol
const formatAmount = (amount, currency) => {
  if (!amount && amount !== 0) return '—';
  const symbol = currency || '';
  return `${symbol}${Number(amount).toLocaleString()}`;
};

export default function AdminGrants() {
  return (
    <AdminCRUD
      endpoint="grants"
      title="Grants"
      icon={Award}
      columns={[
        { key:'title', label:'Grant', render:(v, item) => (
          <div>
            <div className="font-semibold text-gray-900 text-sm">{v}</div>
            <div className="text-xs text-royal-700 font-medium">{item.funder || item.donor || '—'}</div>
          </div>
        )},
        { key:'amount', label:'Amount', render:(v, item) => (
          <span className="font-bold text-royal-800">
            {formatAmount(v, item.currency)}
          </span>
        )},
        { key:'category', label:'Category', render: v => v
          ? <span className="px-2 py-0.5 bg-royal-50 text-royal-700 rounded-full text-xs font-semibold capitalize">{v}</span>
          : '—'
        },
        { key:'status', label:'Status', render: v => (
          <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold capitalize ${STATUS_STYLE[v] || 'bg-gray-100 text-gray-600'}`}>{v}</span>
        )},
        { key:'deadline', label:'Deadline', render: v => v
          ? <span className="text-xs text-gray-500">{new Date(v).toLocaleDateString('en-NG', { day:'numeric', month:'short', year:'numeric' })}</span>
          : '—'
        },
        { key:'isFeatured', label:'Featured', render: v => v
          ? <span className="text-gold-500 font-bold">★</span>
          : <span className="text-gray-300">—</span>
        },
      ]}
      defaultForm={{
        title:'', funder:'', amount:'', currency:'', category:'',
        status:'open', isFeatured:false,
      }}
      formFields={[
        { key:'title',    label:'Grant Title',    required:true, fullWidth:true },
        { key:'funder',   label:'Donor / Funder', required:true },
        { key:'category', label:'Category (e.g. Education, Health, Research)', placeholder:'Type any category' },
        { key:'amount',   label:'Grant Amount (number only)',   type:'number' },
        { key:'currency', label:'Currency Symbol (e.g. ₦, $, £, GMD, €)', placeholder:'e.g. ₦ or GMD ' },
        { key:'status',   label:'Status', type:'select', options:['open','upcoming','closed'] },
        { key:'deadline', label:'Application Deadline', type:'date' },
        { key:'startDate',label:'Grant Start Date',     type:'date' },
        { key:'endDate',  label:'Grant End Date',       type:'date' },
        { key:'description', label:'Description', type:'textarea', fullWidth:true, rows:4 },
        { key:'reportUrl', label:'Guidelines / Report Document', type:'file', accept:'.pdf,.doc,.docx', fullWidth:true },
        { key:'isFeatured', label:'Feature', type:'checkbox', checkLabel:'Feature on website', fullWidth:true },
      ]}
    />
  );
}